import PrivateRoute from '../routes/privateroute';
import './index.css';
import menuicon from '../assests/images/icons/hamburger.svg';
import menuicon_active from '../assests/images/icons/hamburger_green.svg';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useLayoutEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setLogoutRequest } from '../redux/actions/user/login';
import { useSelector } from 'react-redux';
const Layout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [activeLink, setActiveLink] = useState('');
  const [pageName, setPageName] = useState('');
  const [backArrow, setBackArrow] = useState('');
  const [orderNumber, setOrderNumber] = useState('');
  const [sideBarToggle, setSideBarToggle] = useState(false);
  const { user } = useSelector((state: any) => state.LoginReducer);
  const { order } = useSelector((state: any) => state.OrdersDetailReducer);
  const { id } = useParams();

  const highlightSelectedLink = (path: string) => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    setBackArrow('');
    if (path.indexOf('store') !== -1) {
      setActiveLink('store');
      if (path.indexOf('update') !== -1) {
        setPageName('Edit Store Detail');
        setBackArrow('/store');
      } else {
        setPageName('Store Management');
      }
    } else if (path.indexOf('menu') !== -1) {
      setActiveLink('menu');
      if (path.indexOf('item-edit') !== -1) {
        setPageName('Edit Item');
        setBackArrow('/menu');
      } else {
        setPageName('Menu');
      }
    } else if (path.indexOf('featuredcontent') !== -1) {
      setActiveLink('featuredcontent');
      if (path.indexOf('add') !== -1) {
        setPageName('Add Content');
        setBackArrow('/featuredcontent');
      } else if (path.indexOf('update') !== -1) {
        setPageName('Edit Content');
        setBackArrow('/featuredcontent');
      } else {
        setPageName('Featured Content');
      }
    } else if (path.indexOf('gcmembership') !== -1) {
      setActiveLink('gcmembership');
      setPageName('Gravity Club Membership');
    } else if (path.indexOf('customerreport') !== -1) {
      setActiveLink('customerreport');
      if (path.indexOf('detail') !== -1) {
        setPageName('Submitted Tickets');
        setBackArrow('/customerreport');
      } else {
        setPageName('Customer Report');
      }
    } else if (path.indexOf('settings') !== -1) {
      setActiveLink('settings');
      if (path.indexOf('add') !== -1) {
        setPageName('Add Admin User');
        setBackArrow('/adminsettings');
      } else if (path.indexOf('update') !== -1) {
        setPageName('Update Admin User');
        setBackArrow('/adminsettings');
      } else {
        setPageName('Admin Settings');
      }
    } else if (path.indexOf('referral') !== -1) {
      setActiveLink('referral');
      setPageName('Referral');
    } else if (path.indexOf('account') !== -1) {
      setActiveLink('account');
      setPageName('Account');
    } else if (path.indexOf('ordermanagement') !== -1) {
      setActiveLink('ordermanagement');
      if (path.indexOf('detail') !== -1) {
        setBackArrow('/ordermanagement');
      } else {
        setPageName('Order Management');
      }
    } else if (path.indexOf('help') !== -1) {
      setActiveLink('help');
      if (path.indexOf('add') !== -1) {
        setPageName('Add FAQ');
        setBackArrow('/help');
      } else if (path.indexOf('update') !== -1) {
        setPageName('Update FAQ');
        setBackArrow('/help');
      } else {
        setPageName('Help Section');
      }
    } else {
      setActiveLink('menu');
      setPageName('Menu');
    }
  };
  useLayoutEffect(() => {
    highlightSelectedLink(location.pathname);
  }, [location.pathname]);
  useEffect(() => {
    setOrderNumber('');
    highlightSelectedLink(window.location.href);
  }, []);
  useEffect(() => {
    if (order) {
      setPageName(`Order #${order.revelOrderId}`);
    }
  }, [order]);
  const handleLogout = () => {
    dispatch(setLogoutRequest());
    navigate('/');
  };
  return (
    <div id="main-wapper">
      <div id="container">
        <div id="sidebar-content" className={sideBarToggle ? 'collapse' : ''}>
          <div className="top-head">
            <Link to="/" className="logo">
              <img
                src={require('../assests/images/logo.png')}
                alt="Gravity Coffee Logo"
              />
            </Link>
            <div>
              <button
                className="menu-icon"
                onClick={() => setSideBarToggle(!sideBarToggle)}
              >
                {!sideBarToggle ? (
                  <img src={menuicon_active} alt="" />
                ) : (
                  <img src={menuicon} alt="" />
                )}
              </button>
            </div>
          </div>
          <div className={`link-list`}>
            <ul>
              <li className={`${activeLink === 'store' ? ' active' : ''}`}>
                <Link to="/store">
                  <svg
                    width="12"
                    height="16"
                    viewBox="0 0 12 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6 0.6875C3.20116 0.6875 0.9375 2.97632 0.9375 5.80627C0.9375 9.64534 6 15.3125 6 15.3125C6 15.3125 11.0625 9.64534 11.0625 5.80627C11.0625 2.97632 8.79884 0.6875 6 0.6875ZM6 7.6344C5.00196 7.6344 4.19196 6.8154 4.19196 5.80627C4.19196 4.79714 5.00196 3.97813 6 3.97813C6.99803 3.97813 7.80804 4.79714 7.80804 5.80627C7.80804 6.8154 6.99803 7.6344 6 7.6344Z"
                      fill="#C7C7CC"
                    />
                  </svg>
                  <p>Store Management</p>
                </Link>
              </li>
              <li className={`${activeLink === 'menu' ? ' active' : ''}`}>
                <Link to="/menu">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      width="8.18182"
                      height="8.18182"
                      rx="2"
                      fill="#C7C7CC"
                    />
                    <rect
                      x="9.81812"
                      width="8.18182"
                      height="8.18182"
                      rx="2"
                      fill="#C7C7CC"
                    />
                    <rect
                      x="9.81812"
                      y="9.81824"
                      width="8.18182"
                      height="8.18182"
                      rx="2"
                      fill="#C7C7CC"
                    />
                    <rect
                      y="9.81824"
                      width="8.18182"
                      height="8.18182"
                      rx="2"
                      fill="#C7C7CC"
                    />
                  </svg>
                  <p>Menu</p>
                </Link>
              </li>
              <li
                className={`${activeLink === 'featuredcontent' ? ' active' : ''
                  }`}
              >
                <Link to="/featuredcontent">
                  {' '}
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 6C3 5.44772 3.44772 5 4 5H20C20.5523 5 21 5.44772 21 6V7.34711C21 7.89939 20.5523 8.34711 20 8.34711H4C3.44772 8.34711 3 7.89939 3 7.34711V6Z"
                      fill="#C7C7CC"
                    />
                    <path
                      d="M4.38477 18.7272C4.38477 19.2795 4.83248 19.7272 5.38477 19.7272H18.6155C19.1678 19.7272 19.6155 19.2795 19.6155 18.7272V10.0165C19.6155 9.46419 19.1678 9.01648 18.6155 9.01648H5.38477C4.83248 9.01648 4.38477 9.46419 4.38477 10.0165V18.7272ZM9.57707 11.0247C9.57707 10.655 9.87678 10.3553 10.2465 10.3553H13.7538C14.1235 10.3553 14.4232 10.655 14.4232 11.0247C14.4232 11.3945 14.1235 11.6942 13.7538 11.6942H10.2465C9.87678 11.6942 9.57707 11.3945 9.57707 11.0247Z"
                      fill="#C7C7CC"
                    />
                  </svg>
                  <p>Featured Content</p>
                </Link>
              </li>
              <li className={`${activeLink === 'referral' ? ' active' : ''}`}>
                <Link to="/referral">
                  <svg
                    width="16"
                    height="18"
                    viewBox="0 0 16 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1.43442 9.52531C0.524591 9.52531 0 9.10154 0 8.16096V6.27111C0 5.22875 0.59836 4.76266 1.56558 4.76266H3.20492C2.72951 4.28809 2.44263 3.64402 2.44263 2.88979C2.44263 1.21185 3.74591 0 5.36885 0C6.57377 0 7.59834 0.703379 8.00001 1.94066C8.40168 0.703379 9.41804 0 10.6312 0C12.2541 0 13.5574 1.21185 13.5574 2.88979C13.5574 3.64402 13.2705 4.28809 12.7951 4.76266H14.4262C15.4427 4.76266 16 5.22875 16 6.27111V8.16096C16 9.10154 15.4836 9.52531 14.5656 9.52531H8.77053V4.76266H7.22949V3.56776C7.22949 2.37285 6.45906 1.59321 5.50818 1.59321C4.62295 1.59321 4.0082 2.14404 4.0082 3.05081C4.0082 3.97453 4.73775 4.76266 5.99183 4.76266H7.22949V9.52531H1.43442ZM11.9918 3.0508C11.9918 2.14403 11.3771 1.5932 10.4918 1.5932C9.54094 1.5932 8.77052 2.37285 8.77052 3.56775V4.76265H10.0082C11.2623 4.76265 11.9918 3.97452 11.9918 3.0508ZM1.13124 15.7796C1.13124 17.2203 1.95911 18 3.36075 18H7.22958V10.5509H1.13124V15.7796ZM12.6392 18H8.7704V10.5509H14.8687V15.7796C14.8687 17.2203 14.0408 18 12.6392 18Z"
                      fill="#C7C7CC"
                    />
                  </svg>
                  <p>Referral</p>
                </Link>
              </li>
              <li
                className={`${activeLink === 'gcmembership' ? ' active' : ''}`}
              >
                <Link to="/gcmembership">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g opacity="0.8">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M3.56076 3C2.34915 3 1.366 3.97043 1.366 5.16217C1.366 6.35415 2.34919 7.3282 3.56076 7.32802C4.76864 7.32802 5.75179 6.35391 5.75179 5.16217C5.75179 3.9702 4.76841 3 3.56076 3ZM18.1661 11.2935C18.17 11.1865 18.1739 11.0795 18.1739 10.9688V10.9685C18.1739 7.64533 15.4447 4.95238 12.077 4.95238C8.86418 4.95238 6.23196 7.40496 5.99963 10.5143L5.99916 10.5202C5.99167 10.6137 5.98417 10.7074 5.98417 10.8046C5.98026 10.8579 5.98026 10.9153 5.98026 10.9688C5.98026 11.0872 5.98398 11.2056 5.99181 11.324C7.42019 11.6679 9.64996 11.8741 11.9919 11.8741C14.8835 11.8741 16.9854 11.5952 18.1661 11.2935ZM17.0898 14.3952C15.0306 14.5823 13.0758 14.6128 11.9997 14.6128V14.6128C11.2604 14.6128 9.24356 14.5593 7.03316 14.3494C8.12868 15.9423 9.97893 16.989 12.077 16.989C14.1557 16.989 15.9905 15.9614 17.0898 14.3952ZM23.9994 11.2131C23.9994 13.4288 14.9416 13.8489 11.9997 13.8489C9.73513 13.8489 0 13.4324 0 11.2131C0 10.2848 2.19476 9.4674 5.51217 9.00134C5.35735 9.49408 5.26047 10.0023 5.22581 10.5064C3.66192 10.98 3.92515 11.5149 5.29549 11.9274C6.66578 12.3438 9.13555 12.6378 11.9924 12.6378C15.066 12.6378 17.6052 12.3132 18.9021 11.8701C20.0363 11.4805 20.2143 10.9992 18.9524 10.5675C18.9214 10.0442 18.8324 9.52849 18.6815 9.02802C21.8903 9.49796 24 10.304 24 11.2132L23.9994 11.2131ZM23.2602 16.6951C23.2602 17.9863 22.1919 19.0405 20.8835 19.0405C19.5713 19.0405 18.5067 17.9863 18.5067 16.6951C18.5067 15.4001 19.5713 14.3496 20.8835 14.3496C22.1918 14.3496 23.2602 15.4 23.2602 16.6951ZM3.74282 21C5.4809 21 6.89387 19.6095 6.89387 17.8944C6.89387 16.1792 5.4809 14.7887 3.74282 14.7887C2.00866 14.7887 0.595873 16.1792 0.595873 17.8944C0.595873 19.6095 2.00866 21 3.74282 21Z"
                        fill="#C7C7CC"
                      />
                    </g>
                  </svg>
                  <p>Gravity Club Membership</p>
                </Link>
              </li>
              <li
                className={`${activeLink === 'ordermanagement' ? ' active' : ''
                  }`}
              >
                <Link to="/ordermanagement">
                  <svg
                    width="10"
                    height="18"
                    viewBox="0 0 10 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.97434 18H7.02569C8.29619 18 8.93586 17.3345 9.06919 15.8927L9.99311 5.9568C10.0554 5.30057 9.69111 4.86617 9.08694 4.86617H5.80852L5.83518 4.47797C5.87068 4.03433 5.98618 3.78478 6.28827 3.56296L9.26461 1.34471C10.0287 0.771671 9.21128 -0.448368 8.39394 0.170891L5.54201 2.3152C4.83118 2.85127 4.52026 3.4428 4.44026 4.38555L4.40476 4.86617H0.904216C0.308956 4.86617 -0.0553119 5.30982 0.00687996 5.9568L0.930875 15.8927C1.06414 17.3345 1.69492 18 2.97434 18Z"
                      fill="#C7C7CC"
                    />
                  </svg>
                  <p>Order Management</p>
                </Link>
              </li>
              <li className={`${activeLink === 'help' ? ' active' : ''}`}>
                <Link to="/help">
                  <svg
                    width="14"
                    height="18"
                    viewBox="0 0 14 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.5987 4.71716L9.13809 0.157914C9.03938 0.0592005 8.92097 0 8.78289 0H2.26968C1.02622 0 0 1.02636 0 2.26968V15.7303C0 16.9738 1.02636 18 2.26968 18H11.4671C12.7106 18 13.7368 16.9736 13.7368 15.7303V5.0526C13.7368 4.9342 13.6974 4.8158 13.5987 4.71709L13.5987 4.71716ZM5.72359 14.487C5.72359 14.7633 5.50647 14.9804 5.23016 14.9804H3.11838C2.84206 14.9804 2.62495 14.7633 2.62495 14.487V12.3949C2.62495 12.1186 2.84206 11.9015 3.11838 11.9015H5.2303C5.50661 11.9015 5.72373 12.1186 5.72373 12.3949L5.72359 14.487ZM5.72359 9.94746C5.72359 10.2238 5.50647 10.4409 5.23016 10.4409H3.11838C2.84206 10.4409 2.62495 10.2238 2.62495 9.94746V7.85538C2.62495 7.57907 2.84206 7.36195 3.11838 7.36195H5.2303C5.50661 7.36195 5.72373 7.57907 5.72373 7.85538L5.72359 9.94746ZM11.0131 13.9343H7.20386C6.92755 13.9343 6.71044 13.7172 6.71044 13.4409C6.71044 13.1646 6.92755 12.9475 7.20386 12.9475H11.0131C11.2894 12.9475 11.5065 13.1646 11.5065 13.4409C11.5065 13.7172 11.2894 13.9343 11.0131 13.9343ZM11.0131 9.39483H7.20386C6.92755 9.39483 6.71044 9.17771 6.71044 8.9014C6.71044 8.62509 6.92755 8.40798 7.20386 8.40798H11.0131C11.2894 8.40798 11.5065 8.62509 11.5065 8.9014C11.5065 9.17771 11.2894 9.39483 11.0131 9.39483ZM9.73013 4.75663C9.45382 4.75663 9.2367 4.53952 9.2367 4.26321V1.67756L12.2565 4.75649L9.73013 4.75663Z"
                      fill="#C7C7CC"
                    />
                  </svg>
                  <p>Help Section</p>
                </Link>
              </li>
              <li
                className={`${activeLink === 'customerreport' ? ' active' : ''
                  }`}
              >
                <Link to="/customerreport">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.7174 8.15248C10.7174 7.22996 10.9649 6.37509 11.3924 5.60998C11.1673 5.58754 10.9424 5.56494 10.7174 5.56494C6.46494 5.5651 3 9.02996 3 13.2827C3 17.5351 6.46486 21.0001 10.7174 21.0001C14.9699 21.0001 18.4347 17.5352 18.4347 13.2827C18.4347 13.0576 18.4123 12.8328 18.3897 12.6077C17.6472 13.0352 16.7697 13.2827 15.8472 13.2827C13.0124 13.2827 10.7173 10.9877 10.7173 8.1528L10.7174 8.15248Z"
                      fill="#C7C7CC"
                    />
                    <path
                      d="M20.9997 8.15241C20.9997 5.29508 18.7047 3 15.8473 3C13.9347 3 12.2699 4.05748 11.3699 5.60999C15.1048 5.92498 18.0748 8.89486 18.3897 12.6074C19.9423 11.7299 20.9997 10.0649 20.9997 8.15245L20.9997 8.15241Z"
                      fill="#C7C7CC"
                    />
                  </svg>
                  <p>Customer Report</p>
                </Link>
              </li>
              {((user && user.user && user.user.role === 'SuperAdmin') ||
                user == null) && (
                  <li className={`${activeLink === 'settings' ? ' active' : ''}`}>
                    <Link to="/adminsettings">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.6458 6.96359H15.4618C15.3432 6.58676 15.1916 6.22112 15.0086 5.87094L15.8458 5.03362C16.1 4.77971 16.2427 4.43526 16.2427 4.07604C16.2427 3.71683 16.1 3.37222 15.8458 3.11847L14.8818 2.15404C14.6285 1.89902 14.2836 1.756 13.9242 1.757C13.5649 1.75603 13.2201 1.89889 12.9668 2.15375L12.1292 2.99136C11.779 2.80847 11.4135 2.65682 11.0365 2.53822V1.35393C11.0361 0.994967 10.8932 0.65068 10.6392 0.396894C10.3853 0.142986 10.041 0.000285715 9.68202 0H8.31791C7.95895 0.000418537 7.61477 0.143136 7.36087 0.396894C7.10697 0.650801 6.96412 0.994967 6.96355 1.35393V2.53822C6.58673 2.6568 6.22109 2.80845 5.87091 2.99136L5.03358 2.15404C4.78023 1.89902 4.43537 1.756 4.07601 1.757C3.71665 1.75603 3.37176 1.89889 3.11844 2.15375L2.15401 3.11819C1.89982 3.37209 1.75711 3.71654 1.75711 4.07576C1.75711 4.43497 1.89983 4.77958 2.15401 5.03333L2.99161 5.87094C2.80858 6.22111 2.65693 6.58676 2.53836 6.96359H1.35393C0.994966 6.96414 0.650787 7.107 0.396894 7.36091C0.143125 7.61482 0.000392858 7.95898 0 8.31795V9.68206C0.000418537 10.041 0.143136 10.3852 0.396894 10.6391C0.650801 10.893 0.994966 11.0358 1.35393 11.0364H2.53822C2.6568 11.4132 2.80845 11.7789 2.99136 12.1291L2.15404 12.9664C1.89985 13.2203 1.75715 13.5647 1.75715 13.924C1.75715 14.2832 1.89986 14.6276 2.15404 14.8815L3.11847 15.8457V15.8458C3.37224 16.1 3.71683 16.2427 4.07605 16.2427C4.43526 16.2427 4.77973 16.1 5.03362 15.8458L5.87123 15.0082C6.2214 15.1911 6.58691 15.3428 6.96387 15.4614V16.6454C6.96415 17.0045 7.10687 17.3487 7.36077 17.6028C7.61467 17.8567 7.95884 17.9996 8.31795 18H9.68206C10.041 17.9996 10.3853 17.8569 10.6392 17.603C10.8931 17.3491 11.036 17.0049 11.0364 16.6458V15.4618C11.4132 15.3432 11.7789 15.1916 12.1291 15.0086L12.9664 15.846C13.2203 16.1001 13.5647 16.2429 13.924 16.2429C14.2832 16.2429 14.6276 16.1001 14.8815 15.846L15.8457 14.8815H15.8458C16.1 14.6278 16.2427 14.2832 16.2427 13.924C16.2427 13.5647 16.1 13.2203 15.8458 12.9664L15.0082 12.1288C15.1911 11.7786 15.3428 11.4131 15.4614 11.0361H16.6454C17.0045 11.0358 17.3487 10.8931 17.6028 10.6392C17.8567 10.3853 17.9996 10.0412 18 9.68205V8.31794C17.9996 7.95898 17.8569 7.61469 17.603 7.36076C17.3491 7.10685 17.0049 6.96401 16.6458 6.96358L16.6458 6.96359ZM9.00006 12.4465C8.08598 12.4465 7.20944 12.0833 6.56312 11.437C5.9168 10.7906 5.55362 9.91406 5.55362 9.00002C5.55362 8.08598 5.91676 7.20941 6.56312 6.56309C7.20948 5.91676 8.08602 5.55358 9.00006 5.55358C9.91409 5.55358 10.7907 5.91673 11.437 6.56309C12.0833 7.20944 12.4465 8.08598 12.4465 9.00002C12.4455 9.91381 12.0821 10.7898 11.4359 11.4358C10.7898 12.0821 9.91384 12.4455 9.00006 12.4465Z"
                          fill="#C7C7CC"
                        />
                      </svg>
                      <p>Admin Settings</p>
                    </Link>
                  </li>
                )}
              <li className={`${activeLink === 'account' ? ' active' : ''}`}>
                <Link to="/account">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9 18C13.9225 18 18 13.9313 18 9C18 4.07744 13.9225 0 8.99128 0C4.06873 0 0 4.07744 0 9C0 13.9313 4.07744 18 9 18ZM9 12.0058C6.51692 12.0058 4.60019 12.8857 3.68538 13.9051C2.50048 12.6244 1.77735 10.8993 1.77735 9C1.77735 4.99222 4.9835 1.77735 8.99128 1.77735C12.9991 1.77735 16.2226 4.99222 16.2313 9C16.2313 10.8993 15.5082 12.6244 14.3233 13.9138C13.3998 12.8857 11.4831 12.0058 9 12.0058ZM11.9971 7.27496C11.9971 9.1481 10.6902 10.5857 9 10.5769C7.31848 10.5595 6.01166 9.1481 6.00294 7.27496C5.99422 5.51503 7.3272 4.0513 9 4.0513C10.6815 4.0513 11.9971 5.51503 11.9971 7.27496Z"
                      fill="#C7C7CC"
                    />
                  </svg>
                  <p>Account</p>
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div id="main-content" className={sideBarToggle ? 'full-width' : ''}>
          <div className="content-panel">
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {backArrow !== '' && (
                <Link to={backArrow} style={{ paddingRight: '25px' }}>
                  <svg
                    width="8"
                    height="12"
                    viewBox="0 0 8 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.98367 12C6.70331 12 6.46675 11.9079 6.27399 11.7238L1.02589 6.76151C0.780566 6.53557 0.666667 6.29289 0.666667 6C0.666667 5.70711 0.780566 5.45607 1.01713 5.23849L6.27399 0.276151C6.46675 0.0920502 6.70331 0 6.98367 0C7.5444 0 8 0.426778 8 0.962343C8 1.23013 7.8861 1.4728 7.68459 1.67364L3.07607 6.00837L7.68459 10.3347C7.8861 10.5272 8 10.7699 8 11.0377C8 11.5732 7.5444 12 6.98367 12Z"
                      fill="black"
                    />
                  </svg>
                </Link>
              )}
              <h1>{pageName}</h1>
            </div>
            <div className="user-panel">
              <p onClick={() => navigate('/account')} className="name">
                {user && user.user && user.user.email}
              </p>
              <button onClick={() => handleLogout()}>Log Out</button>
            </div>
          </div>
          <PrivateRoute />
        </div>
      </div>
    </div>
  );
};

export default Layout;
